import { admissionMethodApi } from '../../../services';
import {
	createStatsQueryHook,
	createChartQueryHook,
	type StatsQueryParams,
	type ChartQueryParams,
	buildChartSearchParams,
} from '../../../hooks';
import { useQuery } from '@tanstack/react-query';

export type UseAdmissionMethodsQueryParams = StatsQueryParams;
export type UseAdmissionMethodsChartParams = ChartQueryParams;

export const useAdmissionMethodsQuery = createStatsQueryHook({
	entityKey: 'admissionMethods',
	apiFn: (params) => admissionMethodApi.getAdmissionMethodStats(params),
});

export const useAdmissionMethodsLineChartQuery = createChartQueryHook({
	entityKey: 'admissionMethods',
	apiFn: (params) => admissionMethodApi.getNivoLineChartData(params),
});

export const useAdmissionMethodsStackedBarChartQuery = (params?: UseAdmissionMethodsChartParams) => {
	return useQuery({
		queryKey: ['admissionMethods', 'nivo-stacked-bar-chart', params],
		queryFn: async () => {
			const searchParams = buildChartSearchParams(params?.filters);
			return await admissionMethodApi.getNivoStackedBarChartData(searchParams);
		},
		retry: 1,
		refetchOnWindowFocus: false,
	});
};

